import { render, staticRenderFns } from "./report-list.vue?vue&type=template&id=5b504d8e&"
import script from "./report-list.vue?vue&type=script&lang=js&"
export * from "./report-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports